import { render } from "./App.vue?vue&type=template&id=1577ac5d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1577ac5d&lang=css"
script.render = render

export default script